import styled from "styled-components";
import { rem } from "polished";
// import variables, {media} from "../components/styled/themeVariables";

export const Contact = styled.article`
  font-size: ${rem(20)};
  margin-bottom: ${rem(30)};
`;
